export default __webpack_public_path__ + "static/media/Le_Baiser_grand_porte_cle.4d3484f7.png";